import {Helmet} from "react-helmet";

const SEO = ({title, description, content}) => {
    return (
      <>
      <Helmet htmlAttributes>
        <html lang="en" />
        <title>{title} - {description}</title>
        <meta name={description} content={content} />
      </Helmet>
      </>
    );
}

export default SEO
